import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '@/utils/cn';
import { Slot } from '@radix-ui/react-slot';
import { cva } from 'class-variance-authority';
import * as React from 'react';
const brow = 'text-xs uppercase leading-[120%] tracking-widest';
const h3 = 'text-xl md:text-2xl leading-[135%] tracking-tighter';
const h2 = 'text-2xl md:text-4xl leading-[115%] tracking-tighter';
export const headingVariants = cva('font-bold transition-palette-animate', {
    variants: {
        variant: {
            'special-heading': 'text-5xl md:text-8xl leading-[100%] tracking-tighter',
            h1: 'text-4xl md:text-6xl leading-[100%] tracking-tighter',
            'section-heading': 'text-3xl md:text-5xl leading-[110%] tracking-tighter',
            h2: h2,
            'tab-heading': h2,
            h3: h3,
            'sub-heading': `${h3} font-normal`,
            h4: 'text-base md:text-lg leading-[125%] tracking-tight',
            'section-brow': 'text-base md:text-lg leading-[120%] tracking-tight',
            h5: 'text-xs leading-[130%]',
            brow: brow,
            'button-label': brow,
        },
    },
    defaultVariants: {
        variant: 'section-heading',
    },
});
export const SpecialHeading = React.forwardRef(({ variant = 'special-heading', className, asChild, ...props }, forwardedRef) => {
    const Comp = asChild ? Slot : 'h1';
    return _jsx(Comp, { ref: forwardedRef, className: cn(headingVariants({ variant, className })), ...props });
});
export const H1 = React.forwardRef(({ variant = 'h1', className, asChild, ...props }, forwardedRef) => {
    const Comp = asChild ? Slot : 'h1';
    return _jsx(Comp, { ref: forwardedRef, className: cn(headingVariants({ variant, className })), ...props });
});
export const SectionHeading = React.forwardRef(({ variant = 'section-heading', className, asChild, ...props }, forwardedRef) => {
    const Comp = asChild ? Slot : 'h2';
    return _jsx(Comp, { ref: forwardedRef, className: cn(headingVariants({ variant, className })), ...props });
});
export const H2 = React.forwardRef(({ variant = 'h2', className, asChild, ...props }, forwardedRef) => {
    const Comp = asChild ? Slot : 'h2';
    return _jsx(Comp, { ref: forwardedRef, className: cn(headingVariants({ variant, className })), ...props });
});
export const TabHeading = React.forwardRef(({ variant = 'tab-heading', className, asChild, ...props }, forwardedRef) => {
    const Comp = asChild ? Slot : 'h2';
    return _jsx(Comp, { ref: forwardedRef, className: cn(headingVariants({ variant, className })), ...props });
});
export const H3 = React.forwardRef(({ variant = 'h3', className, asChild, ...props }, forwardedRef) => {
    const Comp = asChild ? Slot : 'h3';
    return _jsx(Comp, { ref: forwardedRef, className: cn(headingVariants({ variant, className })), ...props });
});
export const SubHeading = React.forwardRef(({ variant = 'sub-heading', className, asChild, ...props }, forwardedRef) => {
    const Comp = asChild ? Slot : 'div';
    return _jsx(Comp, { ref: forwardedRef, className: cn(headingVariants({ variant, className })), ...props });
});
export const H4 = React.forwardRef(({ variant = 'h4', className, asChild, ...props }, forwardedRef) => {
    const Comp = asChild ? Slot : 'div';
    return _jsx(Comp, { ref: forwardedRef, className: cn(headingVariants({ variant, className })), ...props });
});
export const SectionBrow = React.forwardRef(({ variant = 'section-brow', className, asChild, ...props }, forwardedRef) => {
    const Comp = asChild ? Slot : 'div';
    return _jsx(Comp, { ref: forwardedRef, className: cn(headingVariants({ variant, className })), ...props });
});
export const H5 = React.forwardRef(({ variant = 'h5', className, asChild, ...props }, forwardedRef) => {
    const Comp = asChild ? Slot : 'div';
    return _jsx(Comp, { ref: forwardedRef, className: cn(headingVariants({ variant, className })), ...props });
});
export const Brow = React.forwardRef(({ variant = 'brow', className, asChild, ...props }, forwardedRef) => {
    const Comp = asChild ? Slot : 'div';
    return _jsx(Comp, { ref: forwardedRef, className: cn(headingVariants({ variant, className })), ...props });
});
export const ButtonLabel = React.forwardRef(({ variant = 'button-label', className, asChild, ...props }, forwardedRef) => {
    const Comp = asChild ? Slot : 'div';
    return _jsx(Comp, { ref: forwardedRef, className: cn(headingVariants({ variant, className })), ...props });
});
